module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"editContent":"Edit task","editOptions":"Edit options","stepName":{"hasTitle":"Create task ({title})","default":"Create task"}}}')
  delete Component.options._Ctor
}
